import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../services/util/error.service'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

const INITIAL_STATE = {
  errorMessage: null,
  loadingMessage: null,

  estoques: [],
  selectedEstoque: null,
  posicoesEstoque: [],
  selecionarTodos: false,
}

export default function useRelatorioEtiquetasInternadas() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      async getEstoque(selectedTp) {
        if (!selectedTp) {
          setState(prev => ({ ...prev, errorMessage: 'Selecione um operador logístico' }))
          return
        }
        EstoqueHttp.getEstoques(selectedTp)
          .then(res => {
            setState(prevState => ({
              ...prevState,
              estoques: res.map(e => ({ label: e.name, value: e.id, ...e })),
              loadingMessage: null,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: null,
              errorMessage: errorHandler(err),
            })),
          )
      },

      resetState() {
        setState(prev => ({ ...prev, loadingMessage: null, errorMessage: null }))
      },

      // Events
      onBtnEmitirRelatorioPdf(posicoesEstoque, selectedTp) {
        if (!Array.isArray(posicoesEstoque) || posicoesEstoque.length === 0) {
          setState(prev => ({
            ...prev,
            errorMessage: 'Nenhuma posição de estoque foi selecionada',
          }))
        } else {
          const url = EstoqueHttp.urlReportEtiquetasInternadasEstoque(
            selectedTp,
            posicoesEstoque.map(p => p.id).join(','),
          )
          window.open(url, '_blank')
        }
      },

      onBtnEmitirRelatorioExcel(posicoesEstoque, selectedTp, estoque) {
        if (!Array.isArray(posicoesEstoque) || posicoesEstoque.length === 0) {
          setState(prev => ({
            ...prev,
            errorMessage: 'Nenhuma posição de estoque foi selecionada',
          }))
        } else {
          EstoqueHttp.getEtiquetasInternadasEstoque(
            selectedTp,
            posicoesEstoque.map(p => p.id).join(','),
          )
            .then(res => {
              const excelData = [
                ['Estoque:', estoque.label],
                ['Sequência', 'Endereço', 'Etiquetas'],
              ]

              res.forEach(d => {
                excelData.push(Object.values(d))
              })

              gerarArquivoExcel(
                `Etiquetas Internadas no Estoque`,
                excelData,
                'EtiquetasInternadasEstoque.xlsx',
              )
            })
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                errorMessage: errorHandler(err),
              })),
            )
        }
      },

      onItemClicked(posicaoEstoque) {
        setState(prev => {
          const { posicoesEstoque } = prev
          const index = posicoesEstoque.findIndex(e => e.id === posicaoEstoque.id)
          if (index !== -1) {
            posicoesEstoque[index].selected = !posicoesEstoque[index].selected
          }

          return { ...prev }
        })
      },

      onChangeSelecionarTodos(value) {
        setState(prevState => {
          prevState.selecionarTodos = value
          prevState.posicoesEstoque = prevState.posicoesEstoque.map(e => ({
            ...e,
            selected: value,
          }))
          return { ...prevState }
        })
      },

      onEstoqueChange(estoqueId) {
        setState(prevState => ({ ...prevState, selectedEstoque: estoqueId, posicoesEstoque: [] }))
      },

      onSelectedEstoque(estoqueId, selectedTp) {
        if (!estoqueId || !selectedTp) {
          return
        }
        EstoqueHttp.getPosicoesEstoquesById(selectedTp, estoqueId)
          .then(res => {
            setState(prevState => ({
              ...prevState,
              posicoesEstoque: res,
              loadingMessage: null,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: null,
              errorMessage: errorHandler(err),
            })),
          )
      },
    }
  }, [])

  return { state, localDispatch }
}
